module.exports = __webpack_public_path__ + "static/img/physical_harm.c2c733b9.png";